import { Stack } from '@mui/material';
import PageArea from '../../components/shared/PageArea';
import { StockCountZonesProvider } from './contexts/StockCountZonesContext';
import CountZonesTop from './components/StockCountZonesTop';
import StockCountZonesMain from './components/StockCountZonesMain';
import StockCountZonesCategories from './components/StockCountZonesCategories';
import StockCountZonesItems from './components/StockCountZonesItems';
import StockCountZonesPopups from './components/StockCountZonesPopups';

const StockCountZones = () => {
  return (
    <StockCountZonesProvider>
      <PageArea>
        <Stack spacing={5}>
          <CountZonesTop />
          <StockCountZonesMain />
          <StockCountZonesCategories />
          <StockCountZonesItems />
        </Stack>
      </PageArea>
      <StockCountZonesPopups />
    </StockCountZonesProvider>
  );
};

export default StockCountZones;
